import { PillsInput } from "@mantine/core";
import styled from "styled-components";


export const StyledPillsInput = styled(PillsInput)`
  .mantine-PillsInput-input {
    /* border-color: var(--clr-gray-200); */

    &:focus,
    &:focus-within {
      border-color: var(--clr-primary-400);
    }
  }
`;
